import { BulkMessageService } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/batch/v1/batch.pb';
import { EmailCampaignService } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/email-campaign/v1/emailcampaign.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaBulkMessage = bindHTTP(BulkMessageService);
export const SchemaEmailCampaignService = bindHTTP(EmailCampaignService);
